import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {BatchExportReportDetailsResponseEntity, DialogData} from '../../../shared/models';
import {take} from 'rxjs/operators';
import {batchExportReportDetailsChangedTo} from '../../../store/actions';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../../../store/IAppState';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BatchExportServiceToken, HttpBatchExportService} from '../../services/batch-export.service';
import {ExportedReportsDialogColumn} from '../../batch-export-helper';
import {BatchExportStatus} from '../../../shared/enums';
import {throwReportDownloadError} from '../exported-reports-dialog-helper';

@Component({
  selector: 'app-one-time-exports-table',
  templateUrl: './one-time-exports-table.component.html',
  styleUrls: ['./one-time-exports-table.component.scss']
})
export class OneTimeExportsTableComponent implements OnInit {

  constructor(private readonly ngRedux: NgRedux<IAppState>,
              @Inject(BatchExportServiceToken) private batchExportService: HttpBatchExportService,
              public dialog: MatDialog) {
  }

  @Input() dataSource: BatchExportReportDetailsResponseEntity[] = [];
  @Input() columns: ExportedReportsDialogColumn[] = [];
  @Input() stringColumnsForRowDef: string[] = [];
  @Output() showPostDownloadPopup = new EventEmitter<boolean>();

  private deleteDialogRef: MatDialogRef<ConfirmDialogComponent>;
  BatchExportStatus = BatchExportStatus;

  ngOnInit(): void {
  }

  delete(reportId: number) {
    let dialog = this.deleteDialogRef;
    const service = this.batchExportService;
    const data = this.dataSource;
    const redux = this.ngRedux;
    const row = data.find(e => e.reportId === reportId);
    const reportName = (row && row.reportName.trim()) ? '"' + row.reportName.trim() + '"' : '';
    const dialogData: DialogData = {
      question: `Are you sure you want to delete ${reportName}?`,
      confirmCallback() {
        service.deleteBatchExportInformation(reportId).pipe(take(1)).subscribe(status => {
          const newData = data.filter(e => e.reportId !== reportId);
          redux.dispatch(batchExportReportDetailsChangedTo(newData));
          dialog.close();
        });
      }
    };
    this.deleteDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
    dialog = this.deleteDialogRef;
  }

  openFile(row: BatchExportReportDetailsResponseEntity) {
    const path = row.path.replace(/\\/g, '/');
    this.showPostDownloadPopup.emit(true);
    this.batchExportService.getReportFile(path).subscribe(data => {
      this.batchExportService.updateReadStatus(row.reportId).pipe(take(1)).subscribe(result => {
        if (!result) {
          console.log('ERROR updating exported file status to READ.');
          this.showPostDownloadPopup.emit(false);
          throw new Error('ERROR updating exported file status to READ for file ID: ' + row.reportId);
        }

        const binaryData = [];
        binaryData.push(data);
        const link = URL.createObjectURL(new Blob(binaryData, {type: 'application/zip'}));

        const a: HTMLAnchorElement = document.createElement('a');
        a.href = link;
        a.download = row.reportName.replace(' ', '_') + '.zip';
        // this is necessary as link.click() does not work on the latest firefox
        a.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          URL.revokeObjectURL(link);
          a.remove();
        }, 100);
      }, () => {
        throwReportDownloadError(row.id);
      });
    }, () => {
      throwReportDownloadError(row.id);
    });
  }

}
